import React from "react";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Box, Grid } from "@material-ui/core";
/**
 * CardBody Component ( component usable as container, accept div tree as children, and set card appearance )
 *
 * @export constant
 * @param {*} { ...props }
 * @returns React Material-UI Card
 */

const minWidth = 285;
const maxWidth = 370;
const minHeight = 200;

const useStyles = makeStyles((theme) => ({
  root: {
    width: "368px",
    minWidth: minWidth,
    maxWidth: maxWidth,
    minHeight: minHeight,
    margin: "0 auto",
    padding: "25px",
    borderRadius: 12,
  },
  title: {
    color: theme.palette.primary.main,
    fontFamily: "muli, sans-serif",
    fontStyle: "normal",
    fontWeight: 800,
    textAlign: "center",
    fontSize: "28px",
    padding: "10px",
  },
}));

const CardBody = ({ ...props }) => {
  const { children, cardStyles } = props;
  const theme = useTheme();
  const lengthImg = theme?.logo?.backgroundImage?.length;
  const imgUrl = theme.logo.backgroundImage.substring(5, lengthImg - 2)
  const classes = useStyles();
  return (
    <Card className={classes.root} style={cardStyles}>
      <div>
        <Grid
          container
          justifyContent="center"
          style={{
            paddingTop: "5px",
            paddingBottom: "5px",
          }}
        >
          <Box
            style={{
              width: theme.widthImageLogo || '200px',
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              // paddingTop: "15.64%",
            }}
            component="img"
            src={imgUrl} 
          />
        </Grid>
        <Typography className={classes.title}>{props.title}</Typography>
        {children}
      </div>
    </Card>
  );
};

export default CardBody;
